import React from "react";

export default props => {
    window.location.assign("");
    return <></>;
};
